import { terrainPlotsCoords } from './../../e.elements/scenes/Graveyards/config';
import { Tile } from './../../c.managers/TerrainManager/store.d'
import { coordsToPosition } from './../../e.elements/Grid/scripts/helpers/coordsPositionConverter'
import { GameObject3D } from './../../e.elements/GameElements/classes/types'
import { Object3D, Vector2 } from 'three'
import { GAME_OBJECTS } from '../../e.elements/GameElements/classes/types'
import getGameElementFromObj from '../../e.elements/GameElements/helpers/getGameElementFromObj'
import { COMMANDERS, Spell, SPELL_TYPE } from './../../c.managers/LevelManager/store.d'
import Minion from '../../e.elements/GameElements/classes/Minion'
import TerrainTile from '../../e.elements/GameElements/classes/TerrainTile'
import { Terrain } from '../TerrainController'
import { Battle } from '../BattleController'
import {
  SEL_FLAG_SPELL_CASTED,
} from '../../c.managers/LevelManager/selectors'
import { useSceneStore } from '../../a.scenes/GameScene/store'
import { dispatch, EVENTS_GAME, EVENTS_OBJECTS, once } from '../../b.providers/EventsProvider/EventsProvider'
import { Characters } from '../CharactersController'
import { ActionHitReceived } from '../../f.assets/Characters/scripts/classes/CharacterActions'
import Spells, { SpellObject } from '../../e.elements/GameElements/classes/Spells'
import { CHARACTER_VARIANTS, MAGIC_TYPE } from '../../f.assets/Characters/scripts/constants'
import { SEL_GRID_ORIGIN } from '../../c.managers/TerrainManager/selectors'
import { Audio } from '../AudioController'

export const API = {
  castSpell: async (spell: Spell, obj: Object3D, owner: COMMANDERS) => {
    dispatch(EVENTS_OBJECTS.CAST_SPELL, spell)

    const flagSpellCastedOnState = SEL_FLAG_SPELL_CASTED(useSceneStore.getState())
    const gridOrigin = SEL_GRID_ORIGIN(useSceneStore.getState())
    const throwMagic = useSceneStore.getState().levels.throwMagic

    const gameObject = getGameElementFromObj(obj as GameObject3D)

    // freeze target if character
    if (gameObject.isClass(GAME_OBJECTS.MINION)) {
      const minion = gameObject as Minion
      minion.freeze()
    }

    const burnSpell = () => {
      Battle.updateMana(owner, -spell.cost * 10)
      flagSpellCastedOnState(spell, owner)
    }

    // call orquestrator by spell

    /**
     * GRAVE
     */
    if (spell.type === SPELL_TYPE.GRAVE) {
      
      const tile = getGameElementFromObj(obj as GameObject3D) as TerrainTile
      const el = Terrain.getElementAt(tile.coords)
      const lots = terrainPlotsCoords.map(c => `${c.x}-${c.y}`)
      const isPlotSpot = lots.includes(`${tile.coords.x}-${tile.coords.y}`)
      if (el || isPlotSpot) {
        console.error('Unable to cast, look for an empty space')
        return false
      } else {
        burnSpell()
        
        Terrain.reserveTarget(tile.coords)
        // console.log(coordsToPosition(tile.coords, gridOrigin))

        throwMagic(owner, coordsToPosition(tile.coords, gridOrigin), MAGIC_TYPE.FIRE)
        // run
        await API.castSpellGrave(tile.coords)
      }
    }
    /**
     * SPARK
     */
    if (spell.type === SPELL_TYPE.SPARK) {
      burnSpell()
      const minion = gameObject as Minion
      throwMagic(owner, coordsToPosition(minion.coords, gridOrigin), MAGIC_TYPE.FIRE)
      await API.castSpellSpark(obj)
    }
    /**
     * FIREBALL
     */
    if (spell.type === SPELL_TYPE.FIREBALL) {
      burnSpell()
      const minion = gameObject as Minion
      throwMagic(owner, coordsToPosition(minion.coords, gridOrigin), MAGIC_TYPE.FIRE)
      await API.castSpellFireball(obj)
    }
    /**
     * PETRIFY
     */
    if (spell.type === SPELL_TYPE.PETRIFY_MINION) {
      burnSpell()
      const minion = gameObject as Minion
      throwMagic(owner, coordsToPosition(minion.coords, gridOrigin), MAGIC_TYPE.ICE)
      await API.castPetrify(obj)
    }
    /**
     * DEVIL
     */
    if (spell.type === SPELL_TYPE.DEVIL_MINION) {
      burnSpell()
      const minion = gameObject as Minion
      throwMagic(owner, coordsToPosition(minion.coords, gridOrigin), MAGIC_TYPE.BLACK)
      await API.castDevil(obj)
    }
    /**
     * SWORD
     */
    if (spell.type === SPELL_TYPE.CANDY_SWORD) {
      burnSpell()
      const minion = gameObject as Minion
      throwMagic(owner, coordsToPosition(minion.coords, gridOrigin), MAGIC_TYPE.ICE)
      await API.castCandySword(obj)
    }
    Audio.throwMagic()
  },
  castSpellGrave: async (coords: Vector2) => {
    // when spell gets target position
    once(EVENTS_OBJECTS.MAGIC_IMPACT, () => {
      Terrain.dropGrave(coords)
    })
  },
  castSpellSpark: async (obj: Object3D) => {
    const SPARK_POWER = 5
    const minion = getGameElementFromObj(obj as GameObject3D) as Minion

    // anim spell throwing
    // when spell gets target position
    once(EVENTS_OBJECTS.MAGIC_IMPACT, () => {
      // check if target is still alive
      if (minion.hp > 0) {
        // call damage on target
        minion.receiveHit(new ActionHitReceived({ dealer: new SpellObject(Spells.SPARK), power: SPARK_POWER }))
      }
      // anim impact
      // unfreeze
      minion.unfreeze()
    })
  },
  castSpellFireball: async (obj: Object3D) => {
    const FIREBALL_POWER = Number.MAX_SAFE_INTEGER
    const minion = getGameElementFromObj(obj as GameObject3D) as Minion

    // anim spell throwing
    // when spell gets target position
    once(EVENTS_OBJECTS.MAGIC_IMPACT, () => {
      // check if target is still alive
      if (minion.hp > 0) {
        // call damage on target
        minion.receiveHit(new ActionHitReceived({ dealer: new SpellObject(Spells.SPARK), power: FIREBALL_POWER }))
      }
      // anim impact
      // unfreeze
      minion.unfreeze()
    })
  },
  castPetrify: async (obj: Object3D) => {
    const minion = getGameElementFromObj(obj as GameObject3D) as Minion

    // anim spell throwing
    // when spell gets target position
    once(EVENTS_OBJECTS.MAGIC_IMPACT, () => {
      minion.mutate(CHARACTER_VARIANTS.STATUE)
      minion.changeTeam(COMMANDERS.NOBODY)
    })
  },
  castDevil: async (obj: Object3D) => {
    const minion = getGameElementFromObj(obj as GameObject3D) as Minion

    // anim spell throwing
    // when spell gets target position
    once(EVENTS_OBJECTS.MAGIC_IMPACT, async () => {
      await minion.mutate(CHARACTER_VARIANTS.DIABLO)

      minion.unfreeze()
    })
  },
  castCandySword: async (obj: Object3D) => {
    const minion = getGameElementFromObj(obj as GameObject3D) as Minion

    // anim spell throwing
    // when spell gets target position
    once(EVENTS_OBJECTS.MAGIC_IMPACT, async () => {
      // since it's not a mutation, if we treat candy sword as such, can't coexist with other mutations,
      // which has sense so far
      await minion.mutate(CHARACTER_VARIANTS.CANDY_ARMORED)

      minion.unfreeze()
    })
  },
}
